<template>
    <div class="hostStuff tradingView showTabs secondary-color headerTab openHeader" :style="!showChart?'max-width: 1000px !important;':''">
        <span class="closePOP" @click.prevent="close()"><feather size="13px" type="x"></feather></span>
        <p class="f-16 mb-5 text-center str">{{$t('select_mode_view_suits') }} </p>
        <ul class="d-flex align-items-center">
            <li :class="($route.name == 'home')?'active':''" @click="close()">
                <router-link to="/">
                    <span class="selected">{{$t('selected') }}</span>
                    <div class="fillname">
                        <img src="../../../../../static/website/images/multiChartView-4.svg">
                        <p class="f-12 mb-0">{{$t('basic_chart_view') }}</p>
                    </div>
                </router-link>
            </li>
            <li :class="($route.name == 'grid-view')?'active':''" @click="close()">
                <router-link to="/grid-view">
                    <span class="selected">{{$t('selected') }}</span>
                    <div class="fillname">
                    <img src="../../../../../static/website/images/multiChartView-3.svg">
                      <p class="f-12 mb-0">{{$t('grid_view') }} </p>
                    </div>
                </router-link>
            </li>
            <li :class="($route.name == 'multi-view')?'active':''" @click="close()" v-if="!showChart">
                <router-link to="/multi-view">
                    <span class="selected">{{$t('selected') }}</span>
                    <div class="fillname">
                      <img src="../../../../../static/website/images/multiChartView-2.svg">
                      <p class="f-12 mb-0">{{$t('multi_chart_view') }} </p>
                    </div>
                </router-link>
            </li>
            <li :class="($route.name == 'custom-view')?'active':''" @click="close()">
                <router-link to="/custom-view">
                    <span class="selected">{{$t('selected') }}</span>
                    <div class="fillname">
                      <img src="../../../../../static/website/images/multiChartView-1.svg">
                      <p class="f-12 mb-0">{{$t('custom') }} </p>
                    </div>
                </router-link>
            </li>
        </ul>
        <p class="stg f-12 mt-4 mb-0">* {{$t('settings_effect_trading_page') }} </p>
    </div>
</template>

<script>
import { commonAllmixins } from '@/plugins/commonAll'
export default {
    name: 'right-nav',
    mixins: [commonAllmixins],
    data() {
        return {
            chart_type:'',
        }
    },
    methods:{
        addChartType(value){
            this.$parent.$parent.chart_type = value
            this.$parent.$parent.openHeader = false
            this.$parent.$parent.headerTab = ''
            this.$route.path("/");
        },
        close(){
            this.$parent.$parent.headerTab = ''
            this.$parent.$parent.openHeader = false
        }
    }
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/sidebar-popup/trading-view.vue